import { Carriers } from '../../../../../../../../constants/carriers';
import { AU, NZ } from '../../../../../../../../constants/country-codes';
import { ANZSellerConfirmations, SellerConfirmations, SellerConfirmationsWithCanadaPost } from '../../../../../../../../enums/confirmation';
import Global from '../../../../../../../../store/global-selectors';
import { ACTION_TYPE_REQUEST_CONFIRMATION } from '../../../../../constants/action-types';
import { propertyForUpdateByActionType } from '../property-for-update-by-action-type';

const propertyForUpdate = propertyForUpdateByActionType(ACTION_TYPE_REQUEST_CONFIRMATION);

const ConfirmationOptions = (state) => {
  const labelProviders = state.seller.data.labelProviders;

  const getSellerConfirmations = () => {
    const hadCanadaPostAsCarrier = labelProviders.some((lp) => lp.labelProviderId === Carriers.CANADA_POST.carrierId);

    if (hadCanadaPostAsCarrier) {
      return Object.values(SellerConfirmationsWithCanadaPost);
    }

    let confirmations = {};

    const countryCode = Global.selectSellerHomeCountry(state);
    switch (countryCode) {
      case AU:
      case NZ:
        confirmations = ANZSellerConfirmations;
        break;
      default:
        confirmations = SellerConfirmations;
        break;
    }

    return Object.values(confirmations);
  };

  const sellerConfirmations = getSellerConfirmations();
  return sellerConfirmations.map(({ messageDescriptor }, ordinal) => ({
    [propertyForUpdate]: ordinal,
    messageDescriptor,
  }));
};

export default ConfirmationOptions;
